import { render, staticRenderFns } from "./EstablishmentRoleComponent.vue?vue&type=template&id=53c147b6&"
import script from "./EstablishmentRoleComponent.vue?vue&type=script&lang=js&"
export * from "./EstablishmentRoleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports